import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { AvatarModule } from 'primeng/avatar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { MenuModule } from 'primeng/menu';

import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from "./components/header/header.component";
import { CreditUnionDialogComponent } from './components/credit-union-dialog/credit-union-dialog.component';
import { NotifyUsersDialogComponent } from './components/notify-users-dialog/notify-users-dialog.component';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        CreditUnionDialogComponent,
        NotifyUsersDialogComponent
    ],
    imports: [
        CommonModule,
        AvatarModule,
        TieredMenuModule,
        DynamicDialogModule,
        DropdownModule,
        MenuModule
    ],
    exports: [
        HeaderComponent,
        FooterComponent
    ]
})
export class CoreModule { }